var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDownLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3527 4.84025C2.39915 4.79369 2.45433 4.75675 2.51507 4.73154C2.57582 4.70633 2.64094 4.69336 2.7067 4.69336C2.77247 4.69336 2.83759 4.70633 2.89834 4.73154C2.95908 4.75675 3.01426 4.79369 3.0607 4.84025L8.7067 10.4873L14.3527 4.84025C14.3992 4.79376 14.4544 4.75689 14.5151 4.73173C14.5759 4.70657 14.641 4.69362 14.7067 4.69362C14.7724 4.69362 14.8375 4.70657 14.8983 4.73173C14.959 4.75689 15.0142 4.79376 15.0607 4.84025C15.1072 4.88674 15.1441 4.94193 15.1692 5.00267C15.1944 5.06341 15.2073 5.12851 15.2073 5.19425C15.2073 5.26 15.1944 5.3251 15.1692 5.38584C15.1441 5.44658 15.1072 5.50177 15.0607 5.54825L9.0607 11.5483C9.01426 11.5948 8.95908 11.6318 8.89834 11.657C8.83759 11.6822 8.77247 11.6951 8.7067 11.6951C8.64094 11.6951 8.57582 11.6822 8.51507 11.657C8.45433 11.6318 8.39915 11.5948 8.3527 11.5483L2.3527 5.54825C2.30614 5.50181 2.2692 5.44663 2.24399 5.38589C2.21879 5.32514 2.20581 5.26002 2.20581 5.19425C2.20581 5.12849 2.21879 5.06336 2.24399 5.00262C2.2692 4.94187 2.30614 4.8867 2.3527 4.84025Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownLine);
export default __webpack_public_path__ + "static/media/chevron-down-line.390d221df9bf15db3cf71f9c42deddf9.svg";
export { ForwardRef as ReactComponent };